import React from 'react'

import { IInputProps } from 'core-components/library/inputs'
import { ValidateInput } from 'core-components/library/validation'

import { getOnlyDigitalString } from '../helpers/strings/getOnlyDigitalString'
import { isPhoneE164Format } from '../helpers/ValidationRules'

interface IProps extends IInputProps {
  value: string
  onChange: (value: string) => void
}

export const InternationalPhoneInput = (props: IProps) => {
  const resultValue = `+${getOnlyDigitalString(props.value)}`
  const changeValue = (value: string) => {
    props.onChange(getOnlyDigitalString(value))
  }

  return (
    <ValidateInput
      {...props}
      classes={{
        inputClasses: props.classes,
      }}
      value={resultValue}
      checkFn={isPhoneE164Format}
      onChange={changeValue}
    />
  )
}
